<template>
  <div>
    <breadcrumb/>
    <welcome-list></welcome-list>
  </div>
</template>

<script>
import WelcomeList from "@/components/Welcomes/WelcomeList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    WelcomeList,
    Breadcrumb
  },
};
</script>

